import { noteAllPermission, contactAllPermission, ticketAllPermission, campaignAllPermission, importContactPermission, formAllPermission, opportunityAllPermission, whatsappAllPermission, userAllPermission } from '../constant/permissions';

export default [
    {
        name: 'notes',
        path: '/app/notes',
        component: () => import('@/view/apps/notes/Notes.vue'),
        meta: {
            permission: noteAllPermission,
            title: 'Notes'
        }
    },
    {
        name: 'pipelines',
        path: '/app/pipelines',
        component: () => import('@/view/apps/contacts/Contacts.vue'),
        meta: {
            permission: contactAllPermission,
            title: 'Contactos'
        }
    },
    {
        name: 'contact-import',
        path: '/app/pipelines/import',
        component: () => import('@/view/apps/imports/ImportsAdd.vue'),
        meta: {
            permission: importContactPermission,
            title: 'Importar contactos'
        }
    },
    {
        name: 'tickets',
        path: '/app/tickets',
        component: () => import('@/view/apps/tickets/Tickets.vue'),
        meta: {
            permission: ticketAllPermission,
            title: 'Tickets'
        }
    },
    {
        name: 'ticket-detail',
        path: '/app/tickets/detail/:id',
        component: () => import('@/view/apps/tickets/TicketsDetail.vue'),
        meta: {
            permission: ticketAllPermission,
            title: 'Ticket Detail'
        }
    },
    {
        name: 'campaigns',
        path: '/app/campaigns',
        component: () => import('@/view/apps/campaigns/Campaigns.vue'),
        meta: {
            permission: campaignAllPermission,
            title: 'Campaigns'
        }
    },
    {
        name: 'campaign-detail',
        path: '/app/campaigns/detail/:id',
        component: () => import('@/view/apps/campaigns/CampaignsDetail.vue'),
        meta: {
            permission: campaignAllPermission,
            title: 'Campaign Detail'
        }
    },
    {
        // Se llamaba '/app/whatsapp', pero la bandeja hace rato que no es solo
        // WhatsApp: trae SMS, chat web y Messenger. El nombre viejo se conserva
        // mas abajo como redireccion para no romper los enlaces guardados de
        // quien ya lo tenia en favoritos.
        name: 'conversations',
        path: '/app/conversations',
        component: () => import('@/view/apps/whatsapp/Whatsapp.vue'),
        meta: {
            permission: whatsappAllPermission,
            title: 'Conversaciones'
        }
    },
    {
        // Redireccion del camino viejo. Alguien pudo dejarlo en favoritos, y un
        // 404 en la pantalla que mas se usa no vale la pena por un cambio de
        // nombre. No choca con '/app/whatsapp/clientes' (que esta justo
        // debajo) porque los dos son caminos exactos, no comodines.
        path: '/app/whatsapp',
        redirect: '/app/conversations',
    },
    {
        // Pantalla del admin: crear la cuenta de WhatsApp de cada cliente y
        // conectar su numero. Protegida por user.all (solo la agencia).
        name: 'whatsapp-clients',
        path: '/app/whatsapp/clientes',
        component: () => import('@/view/apps/whatsapp/WhatsappClients.vue'),
        meta: {
            permission: userAllPermission,
            title: 'Clientes y canales'
        }
    },
    {
        name: 'dashboard',
        path: '/app/dashboard',
        component: () => import('@/view/apps/dashboard/Dashboard.vue'),
        meta: {
            title: 'My Dashboard'
        }
    },
    {
        name: 'forms',
        path: '/app/forms',
        component: () => import('@/view/apps/forms/Forms.vue'),
        meta: {
            permission: formAllPermission,
            title: 'Forms'
        }
    },
    {
        name: 'profile',
        path: '/app/profile',
        component: () => import('@/view/apps/profile/Profile.vue'),
        meta: {
            title: 'Profile'
        },
        children: [
            {
                name: 'set-password',
                path: '/app/profile/password',
                component: () => import('@/view/apps/profile/ProfilePassword.vue'),
            },
            {
                name: 'set-social',
                path: '/app/profile/social',
                component: () => import('@/view/apps/profile/ProfileSocial.vue'),
            },
            {
                name: 'set-profile',
                path: '/app/profile/edit',
                component: () => import('@/view/apps/profile/ProfileUpdate.vue'),
            },
            {
                name: 'set-branding',
                path: '/app/profile/marca',
                component: () => import('@/view/apps/profile/ProfileBranding.vue'),
            },
            {
                // Conectar Facebook para recibir leads. Vive aqui y no en
                // Canales porque un lead no es una conversacion: no va a la
                // bandeja, va al embudo.
                name: 'set-facebook-leads',
                path: '/app/profile/leads-facebook',
                component: () => import('@/view/apps/profile/ProfileFacebookLeads.vue'),
            },
            {
                // Los campos a medida de la ficha del contacto. Van junto a los
                // leads de Facebook porque es ahi donde se mapean, pero sirven
                // para todo el CRM.
                name: 'set-custom-fields',
                path: '/app/profile/campos',
                component: () => import('@/view/apps/profile/ProfileCustomFields.vue'),
            }
        ]
    },
    {
        name: 'opportunities',
        path: '/app/opportunities',
        component: () => import('@/view/apps/opportunities/Opportunities.vue'),
        meta: {
            permission: opportunityAllPermission,
            title: 'Opportunities'
        }
    },
    
    /*{
        name: 'set-password',
        path: '/app/profile/password',
        component: () => import('@/view/apps/profile/ProfilePassword.vue'),
    },*/
    

];